// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomerSegmentation_wrapper__qnU94","action-button":"CustomerSegmentation_action-button__iPazf"};